import axiosInstance from "../../api/axios";

const baseUrl = '/resources';

const ResourceService = {

    getPdfFilesByChapter: async (chapterId) => {
        try {
            const response = await axiosInstance.get(`${baseUrl}/${chapterId}`);
            return response.data; // Directly return the response data
        } catch (error) {
            throw error;
        }
    },


    streamPdfFile: async (pdfFileId) => {
        try {
            const response = await axiosInstance.get(`${baseUrl}/${pdfFileId}/stream`, {
                responseType: 'blob',
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Failed to stream PDF file');
            }
        } catch (error) {
            throw error;
        }
    },


    uploadPdfFiles: async (pdfFilesData) => {
        try {
            const formData = new FormData();
            pdfFilesData.forEach((fileData, index) => {
                formData.append(`pdf_file[${index}][title]`, fileData.title);
                formData.append(`pdf_file[${index}][file]`, fileData.file);
                formData.append(`pdf_file[${index}][chapter_id]`, fileData.chapterId);
            });

            const response = await axiosInstance.post(baseUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.status === 201) {
                return response.data;
            } else {
                throw new Error('Failed to upload PDF files');
            }
        } catch (error) {
            throw error;
        }
    },

    deletePdfFile: async (pdfFileId) => {
        try {
            const response = await axiosInstance.delete(`${baseUrl}/${pdfFileId}`);
            if (response.status === 200) {
                return response.data.message;
            } else {
                throw new Error('Failed to delete PDF file');
            }
        } catch (error) {
            throw error;
        }
    },
    downloadPdfFile: async (pdfFileId) => {
        // axiosInstance.defaults.headers.common['Accept'] = 'application/pdf';
        // Remove this line - don't set Content-Disposition in the request
        // axiosInstance.defaults.headers.common['Content-Disposition'] = 'attachment';
        
        try {
            const response = await axiosInstance.get(`${baseUrl}/${pdfFileId}/download`, {
                responseType: 'blob',
            });
            if (response.status === 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                
                // Try to get filename from Content-Disposition header
                const contentDisposition = response.headers['content-disposition'];
                let filename = `document_${pdfFileId}.pdf`;  // Default filename
                
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1].replace(/['"]/g, '');
                    }
                }
                
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                throw new Error('Failed to download PDF file');
            }
        } catch (error) {
            console.error('Download error:', error);
            throw error;
        }
    },

    generateSecureViewUrl: async (pdfFileId) => {
        try {
            const response = await axiosInstance.get(`${baseUrl}/${pdfFileId}/secure-session-url`);
            if (response.status === 200 && response.data.success) {
                return response.data;
            } else {
                throw new Error(response.data.message || 'Failed to generate secure view URL');
            }
        } catch (error) {
            console.error('Secure URL generation error:', error);
            // Handle specific error cases
            if (error.response?.status === 401) {
                throw new Error('Authentication required. Please log in again.');
            } else if (error.response?.status === 403) {
                throw new Error('Access denied. You do not have permission to view this resource.');
            } else if (error.response?.status === 404) {
                throw new Error('PDF file not found.');
            } else if (error.response?.status === 500) {
                throw new Error('Server error. Please try again later.');
            }
            throw error;
        }
    }
};

export default ResourceService;